import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import { WithAuditService } from '@app/assets/common/audit.service';
import { type TestCodeEvent, TestCodeService } from '@app/assets/common/test-code.service';
import type { GlobalFunctionDto } from '@app/assets/function/function.dto';
import { GLOBAL_FUNCTION_PATH } from '@app/shared/api/api-route.config';
import { WithExportableService } from '@app/shared/api/export.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithWorkflowableService } from '@app/shared/approval/workflow.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithCrudVersionService } from '@app/shared/change-log/version.service';
import { WithJobService } from '@app/shared/job-history/job.service';
import { WithLineageService } from '@app/shared/lineage/lineage.service';
import { ToastNotificationService } from '@app/shared/notification/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class GlobalFunctionService extends classes(
    WithCrudVersionService<GlobalFunctionDto>,
    WithAuditService,
    WithLogService,
    WithWorkflowableService,
    WithLineageService,
    WithExportableService,
    WithJobService,
) {
    protected endpoint = GLOBAL_FUNCTION_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
    private readonly testCodeService = inject(TestCodeService);

    runDebugCode(request: { id: number; code: string }): Observable<TestCodeEvent> {
        return this.testCodeService.run(`${this.endpoint}${request.id}/debug_code`, request.code);
    }
}
